module.exports = __webpack_public_path__ + "img/1.18c0b015.jpg";